// Game data for Footie Clash.
// Club/player names & seasons are FACTUAL public info. Ratings are an INDEPENDENT game interpretation.
// Every player has a SPECIFIC position (GK, LB, CB, RB, CM, LM, RM, LW, ST, RW) and can only fill matching slots.
// No official crests/logos — clubs are coloured initial badges.

const POS_CAT = {
  GK: "GK",
  LB: "DEF", CB: "DEF", RB: "DEF",
  CM: "MID", LM: "MID", RM: "MID",
  LW: "FWD", ST: "FWD", RW: "FWD",
};

// Which player positions a given pitch slot label accepts (a little wide-player flexibility only).
const SLOT_POS = {
  GK: ["GK"],
  LB: ["LB"],
  CB: ["CB"],
  RB: ["RB"],
  CM: ["CM"],
  LM: ["LM", "LW"],
  RM: ["RM", "RW"],
  LW: ["LW", "LM"],
  ST: ["ST"],
  RW: ["RW", "RM"],
};

export function slotAccepts(slot, player) {
  return (SLOT_POS[slot.label] || []).includes(player.pos);
}

const CS = [
  { club: "Manchester United", short: "MUN", color: "#DA291C", season: "1998-99", squad: [
    ["Peter Schmeichel","GK",90],["Raimond van der Gouw","GK",76],
    ["Denis Irwin","LB",85],["Phil Neville","LB",80],["Jaap Stam","CB",88],["Ronny Johnsen","CB",82],["David May","CB",76],["Gary Neville","RB",84],
    ["Roy Keane","CM",91],["Paul Scholes","CM",89],["Nicky Butt","CM",82],["Ryan Giggs","LM",90],["David Beckham","RM",89],
    ["Andy Cole","ST",86],["Dwight Yorke","ST",87],["Ole Gunnar Solskjaer","ST",85],["Teddy Sheringham","ST",84],
  ]},
  { club: "Arsenal", short: "ARS", color: "#EF0107", season: "2003-04", squad: [
    ["Jens Lehmann","GK",85],["Stuart Taylor","GK",72],
    ["Ashley Cole","LB",87],["Gael Clichy","LB",78],["Sol Campbell","CB",88],["Kolo Toure","CB",84],["Pascal Cygan","CB",74],["Lauren","RB",83],
    ["Patrick Vieira","CM",91],["Gilberto Silva","CM",84],["Ray Parlour","CM",80],["Robert Pires","LM",89],["Freddie Ljungberg","RM",85],
    ["Thierry Henry","ST",94],["Dennis Bergkamp","ST",89],["Jose Antonio Reyes","LW",82],["Nwankwo Kanu","ST",80],
  ]},
  { club: "Manchester City", short: "MCI", color: "#3f8fc4", season: "2022-23", squad: [
    ["Ederson","GK",88],["Stefan Ortega","GK",78],
    ["Nathan Ake","LB",83],["Ruben Dias","CB",88],["John Stones","CB",85],["Aymeric Laporte","CB",84],["Manuel Akanji","CB",83],["Kyle Walker","RB",85],
    ["Rodri","CM",90],["Kevin De Bruyne","CM",92],["Ilkay Gundogan","CM",87],["Bernardo Silva","CM",88],["Jack Grealish","LM",84],
    ["Erling Haaland","ST",91],["Julian Alvarez","ST",83],["Phil Foden","LW",87],["Riyad Mahrez","RW",86],
  ]},
  { club: "Liverpool", short: "LIV", color: "#C8102E", season: "2019-20", squad: [
    ["Alisson","GK",89],["Adrian","GK",74],
    ["Andrew Robertson","LB",87],["Virgil van Dijk","CB",91],["Joe Gomez","CB",82],["Joel Matip","CB",82],["Dejan Lovren","CB",78],["Trent Alexander-Arnold","RB",87],
    ["Fabinho","CM",86],["Jordan Henderson","CM",85],["Georginio Wijnaldum","CM",84],["Naby Keita","CM",81],["James Milner","CM",80],
    ["Roberto Firmino","ST",87],["Divock Origi","ST",78],["Sadio Mane","LW",90],["Mohamed Salah","RW",91],
  ]},
  { club: "Chelsea", short: "CHE", color: "#034694", season: "2004-05", squad: [
    ["Petr Cech","GK",89],["Carlo Cudicini","GK",78],
    ["Wayne Bridge","LB",79],["John Terry","CB",89],["Ricardo Carvalho","CB",87],["William Gallas","CB",85],["Paulo Ferreira","RB",82],["Glen Johnson","RB",78],
    ["Claude Makelele","CM",87],["Frank Lampard","CM",90],["Joe Cole","CM",84],["Damien Duff","LM",85],["Arjen Robben","RM",86],
    ["Didier Drogba","ST",88],["Eidur Gudjohnsen","ST",83],["Hernan Crespo","ST",85],["Mateja Kezman","ST",76],
  ]},
  { club: "Leicester City", short: "LEI", color: "#0053A0", season: "2015-16", squad: [
    ["Kasper Schmeichel","GK",83],["Mark Schwarzer","GK",72],
    ["Christian Fuchs","LB",80],["Wes Morgan","CB",82],["Robert Huth","CB",82],["Marcin Wasilewski","CB",75],["Danny Simpson","RB",78],["Ritchie De Laet","RB",73],
    ["N'Golo Kante","CM",88],["Danny Drinkwater","CM",82],["Shinji Okazaki","CM",79],["Marc Albrighton","LM",79],["Riyad Mahrez","RW",88],
    ["Jamie Vardy","ST",87],["Leonardo Ulloa","ST",78],
  ]},
  { club: "Blackburn Rovers", short: "BLB", color: "#0a84c4", season: "1994-95", squad: [
    ["Tim Flowers","GK",84],["Bobby Mimms","GK",72],
    ["Graeme Le Saux","LB",84],["Colin Hendry","CB",84],["Ian Pearce","CB",76],["David May","CB",75],["Henning Berg","RB",82],["Jeff Kenna","RB",76],
    ["Tim Sherwood","CM",83],["Mark Atkins","CM",76],["Jason Wilcox","LM",80],["Stuart Ripley","RM",80],
    ["Alan Shearer","ST",92],["Chris Sutton","ST",86],["Mike Newell","ST",78],
  ]},
  { club: "Tottenham Hotspur", short: "TOT", color: "#132257", season: "2016-17", squad: [
    ["Hugo Lloris","GK",86],["Michel Vorm","GK",74],
    ["Danny Rose","LB",82],["Ben Davies","LB",78],["Toby Alderweireld","CB",86],["Jan Vertonghen","CB",85],["Kyle Walker","RB",84],["Kieran Trippier","RB",80],
    ["Victor Wanyama","CM",82],["Mousa Dembele","CM",85],["Eric Dier","CM",80],["Christian Eriksen","CM",87],["Dele Alli","CM",85],
    ["Harry Kane","ST",89],["Vincent Janssen","ST",74],["Son Heung-min","LW",86],
  ]},
  { club: "Newcastle United", short: "NEW", color: "#2b2b2b", season: "1995-96", squad: [
    ["Pavel Srnicek","GK",78],["Shaka Hislop","GK",76],
    ["John Beresford","LB",79],["Philippe Albert","CB",83],["Steve Howey","CB",80],["Darren Peacock","CB",78],["Warren Barton","RB",79],
    ["Rob Lee","CM",83],["Lee Clark","CM",78],["Peter Beardsley","CM",85],["David Ginola","LM",87],["Keith Gillespie","RM",79],
    ["Les Ferdinand","ST",87],["Faustino Asprilla","ST",84],["Steve Watson","RB",75],
  ]},
  { club: "Leeds United", short: "LEE", color: "#1D428A", season: "2000-01", squad: [
    ["Nigel Martyn","GK",83],["Paul Robinson","GK",78],
    ["Ian Harte","LB",80],["Rio Ferdinand","CB",87],["Lucas Radebe","CB",83],["Dominic Matteo","CB",79],["Gary Kelly","RB",79],["Danny Mills","RB",78],
    ["Lee Bowyer","CM",84],["David Batty","CM",82],["Olivier Dacourt","CM",83],["Stephen McPhail","CM",76],["Harry Kewell","LM",86],
    ["Mark Viduka","ST",86],["Alan Smith","ST",82],["Robbie Keane","ST",84],["Michael Bridges","ST",79],
  ]},
  { club: "Everton", short: "EVE", color: "#003399", season: "1994-95", squad: [
    ["Neville Southall","GK",85],["Jason Kearton","GK",70],
    ["Andy Hinchcliffe","LB",78],["Gary Ablett","LB",76],["Dave Watson","CB",80],["Dave Unsworth","CB",76],["Matt Jackson","RB",76],["Earl Barrett","RB",77],
    ["Barry Horne","CM",78],["Joe Parkinson","CM",77],["John Ebbrell","CM",77],["Vinny Samways","CM",77],["Anders Limpar","RM",82],
    ["Duncan Ferguson","ST",84],["Paul Rideout","ST",78],["Daniel Amokachi","ST",80],["Graham Stuart","RM",78],
  ]},
  { club: "Nottingham Forest", short: "NFO", color: "#e53233", season: "1994-95", squad: [
    ["Mark Crossley","GK",78],["Tommy Wright","GK",72],
    ["Stuart Pearce","LB",86],["Steve Chettle","CB",77],["Colin Cooper","CB",78],["Des Walker","CB",82],["Des Lyttle","RB",76],
    ["Lars Bohinen","CM",80],["Scot Gemmill","CM",78],["Ian Woan","LM",78],["Steve Stone","RM",80],["David Phillips","RM",76],
    ["Stan Collymore","ST",86],["Bryan Roy","LW",82],["Kingsley Black","LM",74],
  ]},
  { club: "Wimbledon", short: "WIM", color: "#1560bd", season: "1994-95", squad: [
    ["Hans Segers","GK",73],["Neil Sullivan","GK",72],
    ["Alan Kimble","LB",71],["Dean Blackwell","CB",72],["Scott Fitzgerald","CB",71],["Chris Perry","CB",74],["Kenny Cunningham","RB",75],["Warren Barton","RB",77],
    ["Vinnie Jones","CM",73],["Robbie Earle","CM",78],["Oyvind Leonhardsen","CM",78],["Andy Clarke","LM",70],["Marcus Gayle","RM",74],
    ["Dean Holdsworth","ST",77],["Efan Ekoku","ST",76],["John Fashanu","ST",76],
  ]},
  { club: "Coventry City", short: "COV", color: "#4a90c2", season: "1997-98", squad: [
    ["Magnus Hedman","GK",74],["Steve Ogrizovic","GK",70],
    ["David Burrows","LB",72],["Richard Shaw","CB",73],["Paul Williams","CB",73],["Gary Breen","CB",74],["Roland Nilsson","RB",76],
    ["Gary McAllister","CM",80],["George Boateng","CM",76],["Paul Telfer","RM",73],["Steve Froggatt","LM",73],
    ["Dion Dublin","ST",80],["Darren Huckerby","ST",78],["Noel Whelan","ST",74],["Viorel Moldovan","ST",76],
  ]},
  { club: "Sunderland", short: "SUN", color: "#d0021b", season: "1999-00", squad: [
    ["Thomas Sorensen","GK",78],["Andy Marriott","GK",70],
    ["Michael Gray","LB",74],["Steve Bould","CB",74],["Paul Butler","CB",73],["Jody Craddock","CB",73],["Chris Makin","RB",73],
    ["Kevin Ball","CM",73],["Alex Rae","CM",74],["Gavin McCann","CM",73],["Allan Johnston","LM",75],["Nicky Summerbee","RM",74],
    ["Kevin Phillips","ST",84],["Niall Quinn","ST",81],["Danny Dichio","ST",73],
  ]},
  { club: "Bolton Wanderers", short: "BOL", color: "#1f3a6e", season: "2004-05", squad: [
    ["Jussi Jaaskelainen","GK",79],["Ian Walker","GK",72],
    ["Ricardo Gardner","LB",74],["Bruno N'Gotty","CB",75],["Radhi Jaidi","CB",75],["Tal Ben Haim","CB",75],["Nicky Hunt","RB",72],
    ["Gary Speed","CM",80],["Kevin Nolan","CM",78],["Ivan Campo","CM",78],["Jay-Jay Okocha","CM",82],["Stelios Giannakopoulos","RM",76],
    ["Kevin Davies","ST",78],["El Hadji Diouf","ST",79],["Henrik Pedersen","ST",73],
  ]},
  { club: "Middlesbrough", short: "BOR", color: "#d81e29", season: "1996-97", squad: [
    ["Ben Roberts","GK",71],["Gary Walsh","GK",71],
    ["Curtis Fleming","LB",73],["Nigel Pearson","CB",74],["Steve Vickers","CB",73],["Gianluca Festa","CB",75],["Neil Cox","RB",72],
    ["Emerson","CM",79],["Juninho","CM",85],["Robbie Mustoe","CM",73],["Nick Barmby","CM",78],["Craig Hignett","RM",74],["Phil Stamp","LM",71],
    ["Fabrizio Ravanelli","ST",84],["Mikkel Beck","ST",74],
  ]},
  { club: "Stoke City", short: "STK", color: "#E03A3E", season: "2010-11", squad: [
    ["Asmir Begovic","GK",79],["Carlo Nash","GK",70],
    ["Danny Higginbotham","LB",74],["Ryan Shawcross","CB",78],["Abdoulaye Faye","CB",75],["Marc Wilson","CB",73],["Andy Wilkinson","RB",72],
    ["Glenn Whelan","CM",74],["Dean Whitehead","CM",74],["Rory Delap","CM",74],["Matthew Etherington","LM",76],["Jermaine Pennant","RM",75],
    ["Kenwyne Jones","ST",76],["Jonathan Walters","ST",76],["Ricardo Fuller","ST",74],
  ]},
];

export const clubSeasons = CS.map((cs) => ({
  id: `${cs.short}-${cs.season}`,
  club: cs.club,
  short: cs.short,
  color: cs.color,
  season: cs.season,
  squad: cs.squad.map(([name, pos, rating], pi) => ({
    id: `${cs.short}-${cs.season}-${pi}`,
    name,
    pos,
    cat: POS_CAT[pos],
    rating,
    club: cs.club,
    short: cs.short,
    color: cs.color,
    season: cs.season,
  })),
}));

export const clubs = clubSeasons.map((c) => ({ name: c.club, short: c.short, color: c.color }));
export const seasons = [...new Set(clubSeasons.map((c) => c.season))];

export function randomSpin() {
  const entry = clubSeasons[Math.floor(Math.random() * clubSeasons.length)];
  const sortedSquad = [...entry.squad].sort((a, b) => b.rating - a.rating);
  return {
    club: { name: entry.club, short: entry.short, color: entry.color },
    season: entry.season,
    squad: sortedSquad,
  };
}

export const OPPONENTS = [
  { name: "Manchester City", short: "MCI", color: "#3f8fc4", strength: 0.9 },
  { name: "Liverpool", short: "LIV", color: "#C8102E", strength: 0.86 },
  { name: "Arsenal", short: "ARS", color: "#EF0107", strength: 0.84 },
  { name: "Manchester United", short: "MUN", color: "#DA291C", strength: 0.8 },
  { name: "Chelsea", short: "CHE", color: "#034694", strength: 0.8 },
  { name: "Tottenham Hotspur", short: "TOT", color: "#132257", strength: 0.78 },
  { name: "Newcastle United", short: "NEW", color: "#2b2b2b", strength: 0.76 },
  { name: "Aston Villa", short: "AVL", color: "#6f9fce", strength: 0.72 },
  { name: "Brighton", short: "BHA", color: "#0057B8", strength: 0.7 },
  { name: "West Ham United", short: "WHU", color: "#7A263A", strength: 0.68 },
  { name: "Everton", short: "EVE", color: "#003399", strength: 0.64 },
  { name: "Wolverhampton", short: "WOL", color: "#d99e00", strength: 0.64 },
  { name: "Crystal Palace", short: "CRY", color: "#1B458F", strength: 0.62 },
  { name: "Fulham", short: "FUL", color: "#1a1a1a", strength: 0.6 },
  { name: "Brentford", short: "BRE", color: "#E30613", strength: 0.6 },
  { name: "Nottingham Forest", short: "NFO", color: "#e53233", strength: 0.58 },
  { name: "Leicester City", short: "LEI", color: "#0053A0", strength: 0.56 },
  { name: "Leeds United", short: "LEE", color: "#1D428A", strength: 0.54 },
  { name: "Southampton", short: "SOU", color: "#D71920", strength: 0.5 },
];

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));

// Points are driven by the XI's OVERALL average rating.
export function simulateSeason(xi) {
  const players = xi.map((s) => s.player).filter(Boolean);
  const cap = xi.find((s) => s.player && s.captain)?.player;
  const ratings = players.map((p) => p.rating).concat(cap ? [cap.rating] : []);
  const avg = ratings.reduce((a, r) => a + r, 0) / ratings.length;

  // Map average rating (~70..92) to a season strength 0..1.
  const strength = clamp((avg - 70) / 22, 0, 1);

  // Wins/draws are a direct function of overall rating, with only a little variance.
  let winFrac = 0.10 + strength * 0.82 + (Math.random() - 0.5) * 0.05;
  winFrac = clamp(winFrac, 0.02, 0.98);
  let wins = Math.round(38 * winFrac);
  let draws = Math.round(38 * (0.10 + (1 - strength) * 0.16) + (Math.random() - 0.5) * 2);
  draws = clamp(draws, 0, 38 - wins);
  let losses = 38 - wins - draws;

  // Build the 38-game fixture list and assign a result/scoreline to each.
  let slots = [];
  OPPONENTS.forEach((opp) => {
    slots.push({ opp, home: true });
    slots.push({ opp, home: false });
  });
  slots = shuffle(slots);

  const outcomes = shuffle([
    ...Array(wins).fill("W"),
    ...Array(draws).fill("D"),
    ...Array(losses).fill("L"),
  ]);

  let gf = 0, ga = 0;
  const fixtures = slots.map((fx, i) => {
    const res = outcomes[i];
    let g, c;
    if (res === "W") { g = 1 + Math.floor(Math.random() * 3); c = Math.floor(Math.random() * g); }
    else if (res === "D") { g = Math.floor(Math.random() * 3); c = g; }
    else { c = 1 + Math.floor(Math.random() * 3); g = Math.floor(Math.random() * c); }
    gf += g; ga += c;
    return { mw: i + 1, home: fx.home, opp: fx.opp.name, short: fx.opp.short, color: fx.opp.color, gf: g, ga: c, res };
  });

  const points = wins * 3 + draws;
  let position;
  if (wins === 38) position = 1;
  else if (points >= 95) position = 1;
  else if (points >= 86) position = 2;
  else if (points >= 78) position = 3;
  else if (points >= 70) position = 4 + Math.floor(Math.random() * 2);
  else if (points >= 60) position = 6 + Math.floor(Math.random() * 3);
  else if (points >= 48) position = 9 + Math.floor(Math.random() * 4);
  else if (points >= 38) position = 13 + Math.floor(Math.random() * 4);
  else position = 17 + Math.floor(Math.random() * 4);

  let verdict, perfect = false, title = false;
  if (wins === 38) {
    verdict = "THE IMPOSSIBLE. A perfect, unbeaten 38-0. Legendary.";
    perfect = true; title = true;
  } else if (losses === 0) {
    verdict = "Invincible! Unbeaten across all 38 games \u2014 but not quite perfect.";
    title = position === 1;
  } else if (position === 1) {
    verdict = "Champions! Your all-time XI lifted the title.";
    title = true;
  } else if (position <= 4) {
    verdict = "A brilliant campaign \u2014 top-four finish and continental football secured.";
  } else if (position <= 10) {
    verdict = "A solid mid-table season. A higher-rated XI would climb the table.";
  } else if (position <= 16) {
    verdict = "A scrappy season \u2014 your XI's overall rating left it fighting to survive.";
  } else {
    verdict = "A relegation battle. Draft higher-rated players to rise up the league!";
  }

  return {
    w: wins, d: draws, l: losses, gf, ga, gd: gf - ga,
    points, position, avg: Math.round(avg * 10) / 10,
    form: fixtures.map((f) => f.res), fixtures, verdict, perfect, title,
  };
}

// ---- League table (final 20-team standings for a completed season) ----
function mulberry32(a) {
  return function () {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function seedFrom(str) {
  let h = 1779033703 ^ str.length;
  for (let i = 0; i < str.length; i++) {
    h = Math.imul(h ^ str.charCodeAt(i), 3432918353);
    h = (h << 13) | (h >>> 19);
  }
  return h >>> 0;
}

// Build a believable, deterministic 20-team table with a realistic Premier-League
// points spread: champions ~88, a congested mid-table, and a bottom cluster of ~5
// teams under 40 points (the bottom 3 go down). The player's XI is slotted in by
// its real points/GD, so a 70-point side finishes mid-table — never relegated.
export function buildLeagueTable(summary, teamName) {
  const ranked = [...OPPONENTS].sort((a, b) => b.strength - a.strength);
  const n = ranked.length; // 19 AI teams
  const TOP = 88;
  const BOTTOM = 26;
  const rows = ranked.map((opp, r) => {
    const rng = mulberry32(seedFrom(opp.short + "_" + summary.points));
    // Linear ladder from TOP (strongest) to BOTTOM (weakest) with a little jitter.
    let pts = Math.round(TOP - (r * (TOP - BOTTOM)) / (n - 1) + (rng() - 0.5) * 6);
    pts = clamp(pts, 20, 96);
    // Derive a plausible W/D/L that sums exactly to `pts` over 38 games.
    let draws = clamp(Math.round(7 + rng() * 6), 0, 16);
    let wins = clamp(Math.round((pts - draws) / 3), 0, 38);
    draws = pts - wins * 3;
    if (draws < 0 || draws > 38 - wins) {
      wins = clamp(Math.floor(pts / 3), 0, 38);
      draws = clamp(pts - wins * 3, 0, 38 - wins);
    }
    const l = 38 - wins - draws;
    const gd = Math.round((pts - 50) * 1.05 + (rng() - 0.5) * 12);
    return { name: opp.name, short: opp.short, color: opp.color, w: wins, d: draws, l, gd, points: wins * 3 + draws, isPlayer: false };
  });

  rows.push({
    name: teamName,
    short: (teamName || "YOU").slice(0, 3).toUpperCase(),
    color: "#10B981",
    w: summary.w,
    d: summary.d,
    l: summary.l,
    gd: summary.gd ?? 0,
    points: summary.points,
    isPlayer: true,
  });

  rows.sort((a, b) => b.points - a.points || b.gd - a.gd || b.w - a.w);
  const total = rows.length;
  return rows.map((r, i) => ({ ...r, pos: i + 1, played: r.w + r.d + r.l, relegated: i >= total - 3 }));
}

// ---- Pep Guardiola: imaginary AI opponent with an auto-drafted XI ----
export const PEP = {
  name: "Pep Guardiola",
  avatar: "https://static.prod-images.emergentagent.com/jobs/b59e590a-c823-4f57-bec9-a8b31bc1b827/images/a0e25110d5eca71aa0e11012ff6176d2d94c07d68c9076883c89d5f567465fc1.jpeg",
};

const AUTO_SLOTS = [
  { id: 0, cat: "GK", label: "GK", x: 50, y: 90 },
  { id: 1, cat: "DEF", label: "LB", x: 13, y: 71 },
  { id: 2, cat: "DEF", label: "CB", x: 38, y: 74 },
  { id: 3, cat: "DEF", label: "CB", x: 62, y: 74 },
  { id: 4, cat: "DEF", label: "RB", x: 87, y: 71 },
  { id: 5, cat: "MID", label: "CM", x: 26, y: 50 },
  { id: 6, cat: "MID", label: "CM", x: 50, y: 53 },
  { id: 7, cat: "MID", label: "CM", x: 74, y: 50 },
  { id: 8, cat: "FWD", label: "LW", x: 20, y: 27 },
  { id: 9, cat: "FWD", label: "ST", x: 50, y: 22 },
  { id: 10, cat: "FWD", label: "RW", x: 80, y: 27 },
];

// Auto-draft a full XI the SAME way a player would in 'wager a mate': spin random
// clubs and pick eligible players. Biased to the best available so Pep fields a strong side.
export function autoDraftXi() {
  const xi = AUTO_SLOTS.map((s) => ({ ...s, player: null }));
  const used = new Set();
  const clubCount = {}; // cap how many players can come from any one club
  const MAX_PER_CLUB = 2;
  let guard = 0;
  while (xi.some((s) => !s.player) && guard < 1500) {
    guard++;
    const spin = randomSpin();
    const club = spin.club.name;
    if ((clubCount[club] || 0) >= MAX_PER_CLUB) continue; // already enough from this club
    // From one club spin, place at most ONE player (the best eligible) — so the XI
    // is drawn from many clubs, just like a player drafting in 'wager a mate'.
    let best = null;
    for (const slot of xi) {
      if (slot.player) continue;
      const pick = spin.squad.find((p) => slotAccepts(slot, p) && !used.has(p.name.toLowerCase()));
      if (pick && (!best || pick.rating > best.player.rating)) {
        best = { slot, player: pick };
      }
    }
    if (best) {
      best.slot.player = best.player;
      used.add(best.player.name.toLowerCase());
      clubCount[club] = (clubCount[club] || 0) + 1;
    }
  }
  return xi;
}

export function simulatePepSeason() {
  return simulateSeason(autoDraftXi());
}

// ---- Pep's season tuned to a ~50% win chance vs the player ----
function buildSeasonFromPoints(points, avg) {
  points = clamp(Math.round(points), 0, 114);
  const base = points % 3;
  const candidates = [base, base + 3, base + 6, base + 9, base + 12].filter((d) => {
    const w = (points - d) / 3;
    return w >= 0 && w + d <= 38;
  });
  let draws, wins;
  if (candidates.length) {
    draws = candidates[Math.floor(Math.random() * candidates.length)];
    wins = (points - draws) / 3;
  } else {
    wins = Math.floor(points / 3);
    draws = points - wins * 3;
  }
  let losses = 38 - wins - draws;
  if (losses < 0) { losses = 0; draws = 38 - wins; }

  let slots = [];
  OPPONENTS.forEach((opp) => { slots.push({ opp, home: true }); slots.push({ opp, home: false }); });
  slots = shuffle(slots);
  const outcomes = shuffle([
    ...Array(wins).fill("W"),
    ...Array(draws).fill("D"),
    ...Array(losses).fill("L"),
  ]);
  let gf = 0, ga = 0;
  const fixtures = slots.map((fx, i) => {
    const res = outcomes[i];
    let g, c;
    if (res === "W") { g = 1 + Math.floor(Math.random() * 3); c = Math.floor(Math.random() * g); }
    else if (res === "D") { g = Math.floor(Math.random() * 3); c = g; }
    else { c = 1 + Math.floor(Math.random() * 3); g = Math.floor(Math.random() * c); }
    gf += g; ga += c;
    return { mw: i + 1, home: fx.home, opp: fx.opp.name, short: fx.opp.short, color: fx.opp.color, gf: g, ga: c, res };
  });

  const pts = wins * 3 + draws;
  let position;
  if (wins === 38) position = 1;
  else if (pts >= 95) position = 1;
  else if (pts >= 86) position = 2;
  else if (pts >= 78) position = 3;
  else if (pts >= 70) position = 4 + Math.floor(Math.random() * 2);
  else if (pts >= 60) position = 6 + Math.floor(Math.random() * 3);
  else if (pts >= 48) position = 9 + Math.floor(Math.random() * 4);
  else if (pts >= 38) position = 13 + Math.floor(Math.random() * 4);
  else position = 17 + Math.floor(Math.random() * 4);

  let verdict = "", perfect = false, title = false;
  if (wins === 38) { verdict = "A perfect, unbeaten season."; perfect = true; title = true; }
  else if (losses === 0) { verdict = "Invincible \u2014 unbeaten all season."; title = position === 1; }
  else if (position === 1) { verdict = "Champions!"; title = true; }
  else if (position <= 4) verdict = "A top-four finish.";
  else if (position <= 10) verdict = "A solid mid-table season.";
  else if (position <= 16) verdict = "A scrappy survival season.";
  else verdict = "A relegation battle.";

  return {
    w: wins, d: draws, l: losses, gf, ga, gd: gf - ga,
    points: pts, position, avg: avg ?? 80,
    form: fixtures.map((f) => f.res), fixtures, verdict, perfect, title,
  };
}

function pepTargetPoints(myPoints) {
  if (Math.random() < 0.05) return myPoints; // small chance of a dead heat
  const margin = 1 + Math.floor(Math.random() * 8);
  return clamp(myPoints + (Math.random() < 0.5 ? margin : -margin), 0, 114);
}

// Pep's season anchored to the player's points for an even (~50%) contest.
export function pepSeasonVs(myPoints, xi) {
  const players = (xi || []).map((s) => s.player).filter(Boolean);
  const avg = players.length
    ? Math.round((players.reduce((a, p) => a + p.rating, 0) / players.length) * 10) / 10
    : 80;
  return buildSeasonFromPoints(pepTargetPoints(myPoints), avg);
}
